"use strict";
exports.tasks = (uid) => `/tasks/${uid}`;
exports.task = (uid, taskId) => `/tasks/${uid}/${taskId}`;
exports.taskSessions = (uid, taskId, date) => `/sessions/${uid}/${taskId}/${date}`;
exports.sessions = (uid) => `/sessions/${uid}`;



/** WEBPACK FOOTER **
 ** ./src/api/path.ts
 **/